module.exports = __webpack_public_path__ + "media/images/search_icon-707f36928c5458ec66b1c23404248da0.png";